/* eslint-disable */

/**
 * @source https://github.com/developit/preact-transition-group
 */
'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _excluded = ["childFactory", "transitionLeave", "transitionName", "transitionAppear", "transitionEnter", "transitionLeaveTimeout", "transitionEnterTimeout", "transitionAppearTimeout", "component"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _require = require('preact'),
    Component = _require.Component,
    cloneElement = _require.cloneElement,
    h = _require.h,
    toChildArray = _require.toChildArray;

function assign(obj, props) {
  return Object.assign(obj, props);
}

function getKey(vnode, fallback) {
  var _vnode$key;

  return (_vnode$key = vnode == null ? void 0 : vnode.key) != null ? _vnode$key : fallback;
}

function linkRef(component, name) {
  var cache = component._ptgLinkedRefs || (component._ptgLinkedRefs = {});
  return cache[name] || (cache[name] = function (c) {
    component.refs[name] = c;
  });
}

function getChildMapping(children) {
  var out = {};

  for (var i = 0; i < children.length; i++) {
    if (children[i] != null) {
      var key = getKey(children[i], i.toString(36));
      out[key] = children[i];
    }
  }

  return out;
}

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  var getValueForKey = function getValueForKey(key) {
    return next.hasOwnProperty(key) ? next[key] : prev[key];
  }; // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = {};
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (var i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (var _i = 0; _i < pendingKeys.length; _i++) {
    childMapping[pendingKeys[_i]] = getValueForKey(pendingKeys[_i]);
  }

  return childMapping;
}

var identity = function identity(i) {
  return i;
};

var TransitionGroup = /*#__PURE__*/function (_Component) {
  _inherits(TransitionGroup, _Component);

  var _super = _createSuper(TransitionGroup);

  function TransitionGroup(props, context) {
    var _this;

    _classCallCheck(this, TransitionGroup);

    _this = _super.call(this, props, context);
    _this.refs = {};
    _this.state = {
      children: getChildMapping(toChildArray(toChildArray(_this.props.children)) || [])
    };
    _this.performAppear = _this.performAppear.bind(_assertThisInitialized(_this));
    _this.performEnter = _this.performEnter.bind(_assertThisInitialized(_this));
    _this.performLeave = _this.performLeave.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TransitionGroup, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.currentlyTransitioningKeys = {};
      this.keysToAbortLeave = [];
      this.keysToEnter = [];
      this.keysToLeave = [];
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var initialChildMapping = this.state.children;

      for (var key in initialChildMapping) {
        if (initialChildMapping[key]) {
          // this.performAppear(getKey(initialChildMapping[key], key));
          this.performAppear(key);
        }
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var nextChildMapping = getChildMapping(toChildArray(nextProps.children) || []);
      var prevChildMapping = this.state.children;
      this.setState(function (prevState) {
        return {
          children: mergeChildMappings(prevState.children, nextChildMapping)
        };
      });
      var key;

      for (key in nextChildMapping) {
        if (nextChildMapping.hasOwnProperty(key)) {
          var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key); // We should re-enter the component and abort its leave function

          if (nextChildMapping[key] && hasPrev && this.currentlyTransitioningKeys[key]) {
            this.keysToEnter.push(key);
            this.keysToAbortLeave.push(key);
          } else if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
            this.keysToEnter.push(key);
          }
        }
      }

      for (key in prevChildMapping) {
        if (prevChildMapping.hasOwnProperty(key)) {
          var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);

          if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
            this.keysToLeave.push(key);
          }
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: "_finishAbort",
    value: function _finishAbort(key) {
      var idx = this.keysToAbortLeave.indexOf(key);

      if (idx !== -1) {
        this.keysToAbortLeave.splice(idx, 1);
      }
    }
  }, {
    key: "performAppear",
    value: function performAppear(key) {
      this.currentlyTransitioningKeys[key] = true;
      var component = this.refs[key];

      if (component.componentWillAppear) {
        component.componentWillAppear(this._handleDoneAppearing.bind(this, key));
      } else {
        this._handleDoneAppearing(key);
      }
    }
  }, {
    key: "_handleDoneAppearing",
    value: function _handleDoneAppearing(key) {
      var component = this.refs[key];

      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete this.currentlyTransitioningKeys[key];

      this._finishAbort(key);

      var currentChildMapping = getChildMapping(toChildArray(this.props.children) || []);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        this.performLeave(key);
      }
    }
  }, {
    key: "performEnter",
    value: function performEnter(key) {
      this.currentlyTransitioningKeys[key] = true;
      var component = this.refs[key];

      if (component.componentWillEnter) {
        component.componentWillEnter(this._handleDoneEntering.bind(this, key));
      } else {
        this._handleDoneEntering(key);
      }
    }
  }, {
    key: "_handleDoneEntering",
    value: function _handleDoneEntering(key) {
      var component = this.refs[key];

      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete this.currentlyTransitioningKeys[key];

      this._finishAbort(key);

      var currentChildMapping = getChildMapping(toChildArray(this.props.children) || []);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        this.performLeave(key);
      }
    }
  }, {
    key: "performLeave",
    value: function performLeave(key) {
      // If we should immediately abort this leave function,
      // don't run the leave transition at all.
      var idx = this.keysToAbortLeave.indexOf(key);

      if (idx !== -1) {
        return;
      }

      this.currentlyTransitioningKeys[key] = true;
      var component = this.refs[key];

      if (component.componentWillLeave) {
        component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        this._handleDoneLeaving(key);
      }
    }
  }, {
    key: "_handleDoneLeaving",
    value: function _handleDoneLeaving(key) {
      // If we should immediately abort the leave,
      // then skip this altogether
      var idx = this.keysToAbortLeave.indexOf(key);

      if (idx !== -1) {
        return;
      }

      var component = this.refs[key];

      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete this.currentlyTransitioningKeys[key];
      var currentChildMapping = getChildMapping(toChildArray(this.props.children) || []);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        this.performEnter(key);
      } else {
        var children = assign({}, this.state.children);
        delete children[key];
        this.setState({
          children: children
        });
      }
    }
  }, {
    key: "render",
    value: function render(_ref, _ref2) {
      var childFactory = _ref.childFactory,
          transitionLeave = _ref.transitionLeave,
          transitionName = _ref.transitionName,
          transitionAppear = _ref.transitionAppear,
          transitionEnter = _ref.transitionEnter,
          transitionLeaveTimeout = _ref.transitionLeaveTimeout,
          transitionEnterTimeout = _ref.transitionEnterTimeout,
          transitionAppearTimeout = _ref.transitionAppearTimeout,
          component = _ref.component,
          props = _objectWithoutProperties(_ref, _excluded);

      var children = _ref2.children; // TODO: we could get rid of the need for the wrapper node
      // by cloning a single child

      var childrenToRender = [];

      for (var key in children) {
        if (children.hasOwnProperty(key)) {
          var child = children[key];

          if (child) {
            var ref = linkRef(this, key),
                el = cloneElement(childFactory(child), {
              ref: ref,
              key: key
            });
            childrenToRender.push(el);
          }
        }
      }

      return h(component, props, childrenToRender);
    }
  }]);

  return TransitionGroup;
}(Component);

TransitionGroup.defaultProps = {
  component: 'span',
  childFactory: identity
};
module.exports = TransitionGroup;